import { TaskRoute } from "tm-shared/types";

export const isTaskRoute = (route: string): route is TaskRoute => {
    return Object.values(TaskRoute).includes(route as TaskRoute);
};
